/**
 * 审核立场主体名称比对：用于把默认方案中的自定义立场对应到合同识别主体。
 */

/**
 * 去掉空白、括号和常见企业后缀，便于比对全称与简称。
 */
export function normalizeLegalPartyName(name: string): string {
  return String(name ?? '')
    .replace(/（[^）]{0,40}）/gu, '')
    .replace(/\([^)]{0,40}\)/gu, '')
    .replace(/[\s　·•、，,。.;；:：'"“”‘’]/gu, '')
    .replace(/股份有限公司|有限责任公司|有限公司|集团股份|集团公司|集团/gu, '')
    .toLowerCase();
}

/**
 * 判断两个主体名称是否相同或极大概率指向同一主体。
 */
export function legalPartyNamesLikelyMatch(left: string, right: string): boolean {
  const a = String(left ?? '').trim();
  const b = String(right ?? '').trim();
  if (!a || !b) return false;
  if (a === b) return true;
  if (a.includes(b) || b.includes(a)) return Math.min(a.length, b.length) >= 2;
  const na = normalizeLegalPartyName(a);
  const nb = normalizeLegalPartyName(b);
  if (!na || !nb) return false;
  if (na === nb) return true;
  if (na.includes(nb) || nb.includes(na)) return Math.min(na.length, nb.length) >= 4;
  return false;
}

/**
 * 在识别主体中找出与默认审核立场一致或高度相近的名称。
 * @returns 合同正文中的主体全称；没有足够相近的匹配时返回 null
 */
export function matchLegalReviewPositionToPartyNames(
  preferredName: string,
  partyNames: string[],
): string | null {
  const preferred = String(preferredName ?? '').trim();
  if (!preferred) return null;
  const names = [...new Set(partyNames.map(item => String(item ?? '').trim()).filter(Boolean))];
  const exact = names.find(name => name === preferred);
  if (exact) return exact;
  return names.find(name => legalPartyNamesLikelyMatch(preferred, name)) ?? null;
}
